import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/app/auth-o3/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { GovernanceReport } from './governance-checks.consts';

const API_ROOT = environment.api.productCapture;

@Injectable()
export class GovernanceChecksService {
  constructor(private service: ApiService) {}

  getTestResults(productId: number): Observable<GovernanceReport[]> {
    return this.service
      .get<GovernanceReport[]>(
        `governance-tests/${Number(productId)}`,
        API_ROOT
      )
      .pipe(first());
  }

  runTests(productId: number): Observable<GovernanceReport> {
    return this.service
      .post(`governance-tests`, { productId: Number(productId) }, API_ROOT)
      .pipe(first<GovernanceReport>());
  }
}
